import LostAccessModalImage from 'assets/images/dashboard/LostAcessImage.svg';
import { Button, Grid, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { pricingWebsitePage } from './constants';
import { useDispatch } from 'react-redux';
import {
    setCurrentQuestionData,
    setIsInvestorHistoryOpen,
    setIsQuickResponseOpen,
    setSelectedIdtoView,
    setViewQuestionDetailModalStatus
} from 'store/Questions/actions';

const UpgradetoPremiumAlertNonAdmin = () => {
    const dispatch = useDispatch();
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        // bgcolor: 'background.paper',
        boxShadow: 24
    };
    const handleClick = () => {
        dispatch({
            type: setSelectedIdtoView,
            selectedIdToView: null
        });
        dispatch({ type: setCurrentQuestionData, currentQuestionData: null });
        dispatch({
            type: setViewQuestionDetailModalStatus,
            viewQuestionDetailModalStatus: false
        });
        dispatch({
            type: setIsInvestorHistoryOpen,
            isInvestorHistoryOpen: false
        });

        dispatch({
            type: setIsQuickResponseOpen,
            isQuickResponseOpen: false
        });
        window.open(pricingWebsitePage, '_blank');
    };
    return (
        <Box className="modal-box modal" sx={style}>
            <PerfectScrollbar style={{ maxHeight: '80vh' }}>
                <Box className="modal-body">
                    <Stack direction={'row'} justifyContent={'center'}>
                        <img src={LostAccessModalImage} alt="lost-acess-modal" width={150} height={150} />
                    </Stack>
                    <Grid
                        container
                        flexDirection={'column'}
                        justifyContent={'center'}
                        alignContent={'center'}
                        alignItems={'center'}
                        mt={3}
                        spacing={2}
                    >
                        <Grid item xs={12}>
                            <Typography variant="h1" component="h1" className="title-modal-upgrade text-center fw-500">
                                You dont have permission to upgrade the company account
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="p" component="p" className="subtitle-modal-upgrade text-center">
                                Please contact your company admin for more information.
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Button className="alternate lost-access" onClick={handleClick}>
                                {' '}
                                See upgrade options
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </PerfectScrollbar>
        </Box>
    );
};
export default UpgradetoPremiumAlertNonAdmin;
